/* @flow */

import {type StylesConfig} from 'react-select';
import {colors} from '../colors';
import {selectPickerGenericStyles} from '../select-picker-generic/select-picker-generic-styles';

export const selectPickerBaseStyles: StylesConfig = {
    container: (base) => ({
        ...base,
        pointerEvents: 'all',
    }),
    clearIndicator: (base, state) => ({
        ...base,
        '&:hover': {color: state.isFocused ? colors.roseDk : colors.rose},
    }),
    control: (base, state) => ({
        ...base,
        '&:hover': {},
        backgroundColor: 'transparent',
        cursor: state.isDisabled ? 'default' : 'pointer',
        borderStyle: 'none',
        boxShadow: 'none',
        minHeight: 46,
        outline: 'none',
        borderRadius: 0,
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderBottomStyle: 'solid',
        borderBottomWidth: 2,
        // eslint-disable-next-line no-nested-ternary
        borderBottomColor: state.isDisabled
            ? 'transparent'
            : state.isFocused
            ? colors.orangeLt
            : colors.offWhiteDk,
        transition: 'border 250ms cubic-bezier(0.18, 0.89, 0.45, 1.06)',
    }),
    input: (base) => ({
        ...base,
        fontSize: 20,
        height: 26,
        margin: 0,
        paddingBottom: 0,
        lineHeight: 'normal',
    }),
    valueContainer: (base) => ({
        ...base,
        paddingLeft: 0,
    }),
    menu: (base) => ({
        ...base,
        marginLeft: 1,
    }),
    option: selectPickerGenericStyles.option,
};
